// extracted by mini-css-extract-plugin
export default {"optionsSpinner":"IX0Bl","selectSpinner":"m30Hl","tagIcon":"GpZ9G"};